import React, { useMemo } from 'react'
import { of } from 'rxjs'
import { Avatar, cn, makeStyles, useObservable } from '@cicero/ui'
import { MD5 } from '@cicero/data/utils'
import { UserSchema, useModel } from '../models'

export const UserTile = ({
  id,
  noPad,
  size = 40,
}: {
  id?: string
  noPad?: boolean
  size?: number
}) => {
  const { tile, tileNoPad, tileAvatar, tileCompact } = useStyles()
  const Users = useModel(UserSchema)
  const u = useObservable(() => id ? Users.GET$(id) : of(null), null, [id])
  const sizeStyles = useMemo(() => ({ width: size, height: size }), [])

  return <div className={cn(tile, { [tileNoPad]: noPad, [tileCompact]: size <= 32 } )}>
    <Avatar
      className={tileAvatar}
      src={u ? `https://www.gravatar.com/avatar/${MD5(u.email)}` : undefined}
      style={sizeStyles}
    >U</Avatar>
    { u && size && size > 32 ? <UserDetails user={u} email={size > 38} /> : null }
  </div>
}

export const UserDetails = ({ user, email }: { user: UserSchema, email?: boolean }) => {
  const { nameWrapper, emailWrapper, contentWrapper } = useStyles()

  return <span className={contentWrapper}>
    <span className={nameWrapper}>{user.first_name} {user.last_name}</span>
    { email
      ? <>
        <br />
        <span className={emailWrapper}>{user.email}</span></>
      : null
    }
  </span>
}

const useStyles = makeStyles({
  tile: {
    display: 'flex',
    // padding: 12,
    textTransform: 'none',
    minWidth: 150,
    // justifyContent: 'flex-start',
    alignItems: 'center',
  },
  tileAvatar: {
    border: '2px solid #FFF',
  },
  tileCompact: {
    minWidth: 0,
    padding: 0,
  },
  tileNoPad: {
    padding: 0,
  },
  contentWrapper: {
    paddingLeft: 12,
    textAlign: 'left',
  },
  nameWrapper: {

  },
  emailWrapper: {
    fontSize: 12,
    color: '#AAA',
  },
})
